import { render, staticRenderFns } from "./pre-next.vue?vue&type=template&id=72302587"
import script from "./pre-next.vue?vue&type=script&lang=js"
export * from "./pre-next.vue?vue&type=script&lang=js"
import style0 from "./pre-next.vue?vue&type=style&index=0&id=72302587&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports